// Categorias de nó (preservadas do projeto original).
export const CATEGORIES = ['strategy', 'idea', 'execution'] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_LABEL_PT: Record<Category, string> = {
  strategy: 'Estratégia',
  idea: 'Ideia',
  execution: 'Execução',
};

// Tipos de nó suportados.
export const NODE_TYPES = ['idea', 'text', 'image', 'url', 'universe', 'doc'] as const;
export type NodeType = (typeof NODE_TYPES)[number];

// Paleta neon (mantida do projeto original — usada como cor default por categoria).
export const NEON_PALETTE = {
  cyan: '#00f5ff',
  magenta: '#ff00e5',
  yellow: '#fff200',
  green: '#39ff14',
  orange: '#ff9500',
  purple: '#9d4edd',
} as const;

export const CATEGORY_DEFAULT_COLOR: Record<Category, string> = {
  strategy: NEON_PALETTE.purple,
  idea: NEON_PALETTE.cyan,
  execution: NEON_PALETTE.green,
};

// Roles em workspace.
export const WORKSPACE_ROLES = ['owner', 'admin', 'editor', 'viewer'] as const;
export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];

// Slugs de planos default.
export const DEFAULT_PLAN_SLUGS = ['free', 'starter', 'pro', 'team'] as const;
export type PlanSlug = (typeof DEFAULT_PLAN_SLUGS)[number];

// Módulos de IA.
export const AI_MODULES = [
  'suggest',
  'summary',
  'autolink',
  'rag_chat',
  'embedding',
  'transcribe',
  'voice_agent',
] as const;
export type AIModule = (typeof AI_MODULES)[number];

// Slugs de prompt versionados.
export const AI_PROMPT_SLUGS = [
  'suggest_on_note',
  'summarize',
  'rewrite',
  'translate',
  'autolink',
  'rag_chat_system',
] as const;
export type AIPromptSlug = (typeof AI_PROMPT_SLUGS)[number];

// Provedores integrados no MVP.
export const AI_PROVIDERS = ['openai', 'google', 'openrouter'] as const;
export type AIProviderSlug = (typeof AI_PROVIDERS)[number];

// Status de assinatura.
export const SUBSCRIPTION_STATUSES = [
  'trialing',
  'active',
  'past_due',
  'paused',
  'canceled',
] as const;
export type SubscriptionStatus = (typeof SUBSCRIPTION_STATUSES)[number];

// Métodos de pagamento Mercado Pago.
export const MP_PAYMENT_METHODS = ['pix', 'credit_card', 'boleto'] as const;
export type MPPaymentMethod = (typeof MP_PAYMENT_METHODS)[number];

// Slugs de integrações guardadas cifradas no DB (painel admin).
export const INTEGRATION_SLUGS = [
  'openai',
  'google',
  'google_oauth',
  'openrouter',
  'deepgram',
  'mercadopago',
  'resend',
  'sentry',
  'posthog',
] as const;
export type IntegrationSlug = (typeof INTEGRATION_SLUGS)[number];

// Limites e thresholds.
export const LIMITS = {
  MAX_NODES_FREE: 100,
  MAX_NODE_LABEL_LEN: 200,
  MAX_DOCUMENT_TITLE_LEN: 300,
  MAX_ASSET_BYTES: 25 * 1024 * 1024, // 25 MB por upload
  PRESIGNED_URL_TTL_SEC: 600,
  HISTORY_STACK_LIMIT: 60,
  SHARE_SLUG_LEN: 12,
} as const;
